import React, { useEffect, useRef } from "react";
import { Router as BrowserRouter } from "react-router-dom";
import { PagesSwitch } from "src/navigation/Switch";
import { history } from "src/navigation/store";
import { useHistory } from "src/navigation/useHistory";
import Modal from "src/components/organisms/Modals/index";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { logout, profile } from "src/store/slices/authSlice";
import { normalizeRole, UserRole } from "src/constants/roles";

export const Router: React.FC = () => {
  const { location, action } = useHistory();
  const dispatch = useAppDispatch();
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  // Токен есть, а профиля (роли) нет — например, прошлый вход упал на /profile
  // (email_not_active). Без роли AuthGate рисует пустую страницу, а /login уводит
  // на дашборд, поэтому один раз запрашиваем профиль, при отказе — выходим.
  const needsProfile = isAuthenticated && !user?.type;
  const profileRequested = useRef(false);
  useEffect(() => {
    if (!needsProfile) {
      profileRequested.current = false;
      return;
    }
    if (profileRequested.current) return;
    profileRequested.current = true;
    dispatch(profile()).then((result) => {
      if (profile.rejected.match(result)) dispatch(logout());
    });
  }, [needsProfile, dispatch]);

  let userRole: UserRole | null = null;

  if (isAuthenticated && user?.type) {
    userRole = normalizeRole(user.type);
  }

  return (
    <BrowserRouter
      location={location}
      navigationType={action}
      navigator={history}
    >
      <PagesSwitch userRole={userRole} />
      <Modal />
    </BrowserRouter>
  );
};
